
import './App.scss';
import { Routes,Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Layout/Home';
import About from './components/About';
import Contact from './components/Contact';

function App() {
  return (
    
<>
<Routes>
  
  <Route path="/" element={<Layout/>}>
      <Route index element={<Home/>} />
      <Route path='/about' element={<About/>} />
      <Route path='/contact' element={<Contact/>} />


    </Route>

</Routes>
</>
  );
}

export default App;




// Without Switch:

// If you visit the URL /about/team, both the About and Team components would render because both paths match.


// import { BrowserRouter as Router, Route } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       <Route path="/about" component={About} />
//       <Route path="/about/team" component={Team} />
//     </Router>
//   );
// }


// If you visit the URL /about/team, both the About and Team components would render because both paths match.



// With Switch:


// import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       <Switch>
//         <Route path="/about/team" component={Team} />
//         <Route path="/about" component={About} />
//       </Switch>
//     </Router>
//   );
// }











// Route 

// display this particular component. 

// Basic Usage:

// First, a simple setup where we have three components - Home, About, and Profile - and we want to route between them:


// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       <div>
//         <nav>
//           <ul>
//             <li><Link to="/">Home</Link></li>
//             <li><Link to="/about">About</Link></li>
//             <li><Link to="/profile">Profile</Link></li>
//           </ul>
//         </nav>

//         {/* Routes */}
//         <Route exact path="/" component={Home} />
//         <Route path="/about" component={About} />
//         <Route path="/profile" component={Profile} />
//       </div>
//     </Router>
//   );
// }

// function Home() {
//   return <h2>Home Page</h2>;
// }

// function About() {
//   return <h2>About Page</h2>;
// }

// function Profile() {
//   return <h2>Profile Page</h2>;
// }

// export default App;
// In the above code:

// We have three Link components that allow users to navigate between routes.

// We defined three Route components to specify which component should be displayed based on the URL.

// The exact prop ensures the Home component is only displayed when the URL is exactl










// Router 


// Without react-router-dom and the history API:

// When you click a link to go from "Home" to "Profile", the browser would traditionally make a new request to the server, fetching a new HTML page and causing a full page reload.




// With react-router-dom using the HTML5 history API:

// When you click a link to navigate from "Home" to "Profile", instead of making a full page request, react-router-dom uses the history API to change the URL (e.g., from http://yourapp.com/ to http://yourapp.com/profile).

// The Route component detects this URL change and switches the rendered component from Home to Profile without a page reload.

// The Switch component ensures that only one route (or its respective component) is rendered at a time.





// Certainly! The HTML5 history API provides a way for web applications to manipulate the browser history and URL without causing a full page refresh. This is a crucial feature for Single Page Applications (SPAs) where only parts of the page change as you navigate between "routes".
